import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useMount } from 'react-use';

import { useNamedLogger } from '@eluve/logger';
import { isBrowserSupported } from '@eluve/utils';

import { UnsupportedBrowserPage } from './UnsupportedBrowserPage';

export const BrowserCompatibilityGate = () => {
  const [result] = useState(() => isBrowserSupported());
  const [bypassed, setBypassed] = useState(false);
  const logger = useNamedLogger('BrowserCompatibilityGate');

  useMount(() => {
    if (!result.supported) {
      logger.warn('Unsupported browser detected', {
        unsupportedFeatures: result.unsupportedFeatures,
      });
    }
  });

  if (!bypassed && !result.supported) {
    return (
      <UnsupportedBrowserPage
        onContinue={() => {
          logger.warn('User continued with unsupported browser', {
            unsupportedFeatures: result.unsupportedFeatures,
          });
          setBypassed(true);
        }}
      />
    );
  }

  return <Outlet />;
};
